<template>
    <!-- <Popup /> -->
    <Head>
        <title>{{title}}</title>
        <meta name="description" :content="description">
    </Head>
    <Header v-if="!isReseau" :agency="agency" :bg_img="bg_img"></Header>
    <ReseauHeader v-else :bg_img="bg_img"></ReseauHeader>
    <Layout>
        <!-- Hometemplate.php -->
        <div class="to-buy-page-template">
            <section class="page-header-section full-view-header content-in-center no-margin">
                <div class="image-block"
                     style="background-image: url('https://www.ewigo.com/wp-content/uploads/2025/02/trouvez_votre_voiture-min.png')">
                </div>
                <div class="container">
                    <h1 class="h1 white anim fade right">Trouvez le véhicule de<br>vos rêves</h1>
                    <h4 class="h4 white anim fade right delay1">pour parcourir les routes en toute sérénité</h4>
                    <div class="form-section">
                        <div class="form-block anim fade right delay2">
                            <div class="input-box">
                                <input type="text" placeholder="Recherche de mon véhicule" v-model="kw">
                            </div>
                            <a class="submit-button" href="#points-of-sale-grid-section">
                                <input type="submit">
                            </a>
                        </div>
                    </div>

                    <!-- Section des filtres actifs -->
                    <ActiveFiltersBar
                        :filter="filter"
                        @remove-filter="removeFilter"
                        @remove-simple-filter="removeSimpleFilter"
                        @clear-all-filters="clearAllFilters"
                    />

                    <div class="search-section anim fade up delay3">
                        <div class="search-list">
                            <!-- Première rangée : 4 filtres -->
                            <FilterDropdown
                                label="Type"
                                :is-active="activeFilter == 'type'"
                                @toggle="toggleFilter('type')"
                            >
                                <FilterCheckboxList
                                    :items="choices.categories"
                                    v-model="filter.type"
                                    item-key="category"
                                />
                            </FilterDropdown>

                            <FilterDropdown
                                label="Marque"
                                :is-active="activeFilter == 'brand'"
                                @toggle="toggleFilter('brand')"
                            >
                                <FilterCheckboxList
                                    :items="choices.makes"
                                    v-model="filter.marque"
                                    item-key="make"
                                />
                            </FilterDropdown>

                            <FilterDropdown
                                label="Modèle"
                                :is-active="activeFilter == 'model'"
                                @toggle="toggleFilter('model')"
                            >
                                <FilterCheckboxList
                                    :items="choices.models"
                                    v-model="filter.modele"
                                    item-key="model"
                                />
                            </FilterDropdown>

                            <FilterDropdown
                                label="Carburant"
                                :is-active="activeFilter == 'energy'"
                                @toggle="toggleFilter('energy')"
                            >
                                <FilterCheckboxList
                                    :items="choices.energies"
                                    v-model="filter.energie"
                                    item-key="energy"
                                />
                            </FilterDropdown>

                            <!-- Deuxième rangée : 4 filtres -->
                            <FilterDropdown
                                label="Boîte de vitesse"
                                :is-active="activeFilter == 'gear'"
                                @toggle="toggleFilter('gear')"
                            >
                                <FilterCheckboxList
                                    :items="choices.vitesses"
                                    v-model="filter.vitesse"
                                />
                            </FilterDropdown>
                            <FilterDropdown
                                label="Année"
                                :is-active="activeFilter == 'year'"
                                @toggle="toggleFilter('year')"
                            >
                                <div class="box">
                                    <span class="label-input">Min : </span>
                                    <input class="filter-input" type="number"
                                        placeholder="Rentrer année min" v-model="filter.year_min"
                                        :min="0"
                                        :max="100000"/>
                                </div>
                                <div class="box">
                                    <span class="label-input">Max : </span>
                                    <input class="filter-input" type="number"
                                        placeholder="Rentrer année max" v-model="filter.year_max"
                                        :min="0"
                                        :max="100000"/>
                                </div>
                            </FilterDropdown>

                            <FilterDropdown
                                label="Kms max"
                                :is-active="activeFilter == 'km'"
                                @toggle="toggleFilter('km')"
                            >
                                <div class="box">
                                    <span class="label-input">Min : </span>
                                    <input class="filter-input" type="number"
                                        placeholder="Rentrer kms min" v-model="filter.kms_min"
                                        :min="0"
                                        :max="150000"/>
                                </div>
                                <div class="box">
                                    <span class="label-input">Max : </span>
                                    <input class="filter-input" type="number"
                                        placeholder="Rentrer kms max" v-model="filter.kms_max"
                                        :min="0"
                                        :max="150000"/>
                                </div>
                            </FilterDropdown>

                            <FilterDropdown
                                label="Prix max"
                                :is-active="activeFilter == 'price'"
                                @toggle="toggleFilter('price')"
                            >
                                <div class="box">
                                    <span class="label-input">Min : </span>
                                    <input class="filter-input" type="number"
                                        placeholder="Rentrer prix min" v-model="filter.price_min"
                                        :min="0"
                                        :max="100000"/>
                                </div>
                                <div class="box">
                                    <span class="label-input">Max : </span>
                                    <input class="filter-input" type="number"
                                        placeholder="Rentrer prix max" v-model="filter.price_max"
                                        :min="0"
                                        :max="100000"/>
                                </div>
                            </FilterDropdown>

                            <!-- Troisième rangée : 2 filtres -->
                            <FilterDropdown
                                label="Nombre de place(s)"
                                :is-active="activeFilter == 'seats'"
                                @toggle="toggleFilter('seats')"
                            >
                                <FilterCheckboxList
                                    :items="choices.seats"
                                    v-model="filter.places"
                                />
                            </FilterDropdown>
                            <div class="list">
                                <div class="box-header filter-reliable">
                                     <div class="check-box-custom">
                                        <input type="checkbox" :value="true" v-model="filter.reliable">
                                        <div class="data">
                                            Fiable ou remboursé
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="points-of-sale-grid-section" id="points-of-sale-grid-section">
                <div class="container">
                    <div class="search-header">
                        <div>
                            <p><b>{{ totalResults }}</b> Résultats</p>
                        </div>
                        <div class="sort-by">
                            <select name="" id="" v-model="sort">
                                <option value="" selected>Trier par</option>
                                <option v-for="item in sortBy" :value="item.value" :key="item.value">{{ item.label }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="posts-list-grid" v-if="!isReseau && ads && ads.data && ads.data.length">
                        <div class="row">
                            <template v-for="(item, index) in ads.data" :key="item.id+JSON.stringify(favoris)">

                                <ad :ad="item" :network="false" :favoris="favoris" v-if="favoris"></ad>

                                <div class="col-lg-4 col-md-6 post-pub" v-if="index == 1">
                                    <a :href="route('minisite.services')+'#livraison'">
                                        <div class="post-block to-buy-list featured">
                                            <div class="thumbnail thumbnail-contain"
                                                 style="background-image: url('https://www.ewigo.com/wp-content/uploads/2021/10/Groupe-362@2x.png');"></div>
                                        </div>
                                    </a>
                                </div>

                                <div class="col-lg-4 col-md-6 post-pub" v-if="index == 4">
                                    <a :href="route('minisite.services')+'#financement'">
                                        <div class="post-block to-buy-list featured">
                                            <div class="thumbnail thumbnail-contain"
                                                 style="background-image: url('https://www.ewigo.com/wp-content/uploads/2021/10/Groupe-363@2x.png');"></div>
                                        </div>
                                    </a>
                                </div>

                                <div class="col-lg-4 col-md-6 post-pub" v-if="index == 7">
                                    <a :href="route('minisite.services')+'#garantie'">
                                        <div class="post-block to-buy-list featured">
                                            <div class="thumbnail thumbnail-contain"
                                                 style="background-image: url('https://www.ewigo.com/wp-content/uploads/2022/05/Garantie-1.png');"></div>
                                        </div>
                                    </a>
                                </div>

                                <div class="col-lg-4 col-md-6 post-pub" v-if="index == 10">
                                    <a :href="route('minisite.services')+'#pack'">
                                        <div class="post-block to-buy-list featured">
                                            <div class="thumbnail thumbnail-contain"
                                                 style="background-image: url('https://www.ewigo.com/wp-content/uploads/2022/05/pack.png');"></div>
                                        </div>
                                    </a>
                                </div>


                            </template>

                        </div>
                    </div>
                    <div class="separator-list-grid" v-if="!isReseau">
                        <hr>
                        <div class="row">
                            <p>Ces véhicules présents dans d'autres points de vente pourraient vous intéresser.
                                Bénéficiez de la livraison dans toute le France !</p>
                        </div>
                    </div>
                    <div class="posts-list-grid">
                        <div class="row">
                            <ad v-for="item in filteredAdsNetwork" :key="item.id+JSON.stringify(favoris)" :ad="item" :network="true" :favoris="favoris"></ad>
                        </div>
                    </div>
                    <div class="posts-list-grid">
                        <div class="row justify-content-center">
                            <pagination class="mt-6" :links="adsNetwork.links"/>
                        </div>
                    </div>
                </div>
            </section>
        </div>


    </Layout>
    <Footer v-if="!isReseau" :agency="agency" :bg_img="bg_img"></Footer>
    <ReseauFooter v-else :bg_img="bg_img"></ReseauFooter>
</template>

<script>
import _, {throttle} from 'lodash';
import Layout from './Layout'
import {Head} from '@inertiajs/inertia-vue3'
import Footer from '@/Pages/Partials/Footer'
import Header from '@/Pages/Partials/Header'
import ReseauFooter from '@/Pages/Partials/ReseauFooter'
import ReseauHeader from '@/Pages/Partials/ReseauHeader'
import Ad from '@/Pages/Partials/Ad'
import Pagination from '@/Components/Pagination'
import ActiveFiltersBar from '@/Components/ActiveFiltersBar'
import FilterDropdown from '@/Components/FilterDropdown'
import FilterCheckboxList from '@/Components/FilterCheckboxList'

export default {
    components: {
        Head,
        Layout,
        Footer,
        Header,
        ReseauFooter,
        ReseauHeader,
        Ad,
        Pagination,
        ActiveFiltersBar,
        FilterDropdown,
        FilterCheckboxList,
    },
    props: {
        agency: Object,
        makes: Object,
        models: Object,
        categories: Object,
        energies: Object,
        ads: Object,
        bg_img: String,
        adsNetwork: Object,
        body_class: String,
        title: String,
        description: String,
        isReseau: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            activeFilter: null,
            filter: {
                type: [],
                marque: [],
                modele: [],
                energie: [],
                vitesse: [],
                kms_min: null,
                kms_max: null,
                year_min: null,
                year_max: null,
                price_min: null,
                price_max: null,
                reliable: false,
                places: [],
            },
            choices: {
                makes: [],
                models: [],
                energies: [],
                categories: [],
                vitesses: ['Automatique', 'Manuelle'],
                seats: ['2', '3', '4', '5', '6', '7', '8+'],
            },
            sort: '-id',
            kw: '',
            sortBy: [
                {value: '-id', label: 'Date du + au - récent'},
                {value: 'id', label: 'Date du - au + récent'},
                {value: '-price', label: 'Prix du + au - cher'},
                {value: 'price', label: 'Prix du - au + cher'},
            ],
            favoris: [],
        }
    },
    watch: {
        makes: {
            immediate: true,
            handler(val) {
                this.choices.makes = val || [];
            }
        },
        models: {
            immediate: true,
            handler(val) {
                // Aucune marque sélectionnée = tous les modèles ; sinon la liste est gérée par le watcher filter.marque
                if (!this.filter.marque || this.filter.marque.length === 0) {
                    this.choices.models = val || [];
                }
            }
        },
        energies: {
            immediate: true,
            handler(val) {
                this.choices.energies = val || [];
            }
        },
        categories: {
            immediate: true,
            handler(val) {
                this.choices.categories = val || [];
            }
        },
        filter: {
            deep: true,
            handler: _.debounce(function () {
                this.$inertia.get(this.acheterRoute + '?' + this.queryString, {}, {
                    preserveState: true,
                    preserveScroll: true
                })
            }, 300)
        },
        kw: {
            deep: true,
            handler: _.debounce(function () {
                this.$inertia.get(this.acheterRoute + '?' + this.queryString, {}, {
                    preserveState: true,
                    preserveScroll: true
                })
            }, 100)
        },
        sort: {
            deep: true,
            handler: _.debounce(function () {
                this.$inertia.get(this.acheterRoute + '?' + this.queryString, {}, {
                    preserveState: true,
                    preserveScroll: true
                })
            }, 100)
        },
        'filter.marque': {
            immediate: true,
            handler: throttle(function () {
                if (!this.filter.marque || this.filter.marque.length === 0) {
                    this.choices.models = this.models || [];
                    return;
                }
                axios.get(route('minisite.models', {makes: this.filter.marque}))
                    .then((response) => {
                        this.choices.models = response.data || [];
                    });
            }, 500)
        }
    },
    created() {
        if (route().params.filter) {
            this.setRouteFilters();
        }

        axios.get(route('api.favoris.get')).then((response) => {
            this.favoris = Object.values(response.data)
        });
    },
    mounted() {
        document.body.classList.add(this.body_class.split(' '))
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                const href = this.getAttribute('href');
                if (!href || href === '#') return;
                const target = document.querySelector(href);
                if (!target) return;
                e.preventDefault();
                const elToGoPosition = document.querySelector(this.getAttribute('href')).getBoundingClientRect().top + window.pageYOffset;
                const headerHeight = document.getElementById('masthead').getBoundingClientRect().height;
                window.scrollTo({
                    top: elToGoPosition - headerHeight,
                    behavior: 'smooth'
                });
            });
        });
    },
    destroyed() {
        document.body.classList.remove(this.body_class.split(' '))
    },
    computed: {
        acheterRoute() {
            return this.isReseau ? route('reseau.acheter') : route('minisite.acheter');
        },
        totalResults() {
            const adsTotal = (this.ads && this.ads.total) ? this.ads.total : 0;
            const networkTotal = (this.adsNetwork && this.adsNetwork.total) ? this.adsNetwork.total : 0;
            return adsTotal + networkTotal;
        },
        queryString() {
            let string = '';
            if (this.filter) {
                _.forEach(this.filter, (value, key) => {
                    if (value === null || value === undefined) {
                        return;
                    }
                    if (Array.isArray(value)) {
                        if (value.length === 0) {
                            return;
                        }
                        string += `filter[${key}]=${encodeURIComponent(value.join(','))}&`;
                    } else if (typeof value === 'boolean') {
                        string += `filter[${key}]=${encodeURIComponent(String(value))}&`;
                    } else {
                        string += `filter[${key}]=${encodeURIComponent(String(value))}&`;
                    }
                });
            }
            string += `sort=${encodeURIComponent(this.sort)}&`;
            string += `kw=${encodeURIComponent(this.kw || '')}`;

            return string;
        },
        filteredAdsNetwork() {
            if (!this.favoris) {
                return [];
            }
            return this.adsNetwork.data;
        }
    },
    methods: {
        toggleFilter(filter) {
            if (this.activeFilter == filter) {
                this.activeFilter = null;
            } else {
                this.activeFilter = filter;
            }
        },
        setRouteFilters() {
            let filters = route().params.filter
            _.forEach(filters, (filter, name) => {
                // Filtres simples (prix, kms, année)
                if (name == 'price_max' || name == 'kms_max' || name == 'price_min' || name == 'kms_min' || name == 'year_min' || name == 'year_max') {
                    // Ne set que si la valeur n'est pas vide
                    this.filter[name] = (filter && filter !== '' && filter !== '0') ? filter : null
                } else if (name == 'reliable') {
                    // Filtre reliable (boolean)
                    this.filter[name] = filter === 'true' || filter === true
                } else if (filter && filter !== '') {
                    // Filtres tableaux (type, marque, modèle, etc.) - Ne split que si la valeur n'est pas vide
                    const values = filter.split(',').filter(v => v !== '' && v !== null);
                    this.filter[name] = values.length > 0 ? values : []
                } else {
                    this.filter[name] = []
                }
            })
        },
        removeFilter(filterKey, value) {
            const index = this.filter[filterKey].indexOf(value);
            if (index > -1) {
                this.filter[filterKey].splice(index, 1);
            }
        },
        removeSimpleFilter(filterKey) {
            if (filterKey === 'reliable') {
                this.filter[filterKey] = false;
            } else {
                this.filter[filterKey] = null;
            }
        },
        clearAllFilters() {
            this.filter = {
                type: [],
                marque: [],
                modele: [],
                energie: [],
                vitesse: [],
                kms_min: null,
                kms_max: null,
                year_min: null,
                year_max: null,
                price_min: null,
                price_max: null,
                reliable: false,
                places: [],
            };
            this.kw = '';
        },
    },

}
</script>
<style scoped lang="scss">

.separator-list-grid {
    margin: 60px 20px;

    p {
        text-align: center;
        width: 100%;
    }
}

.submit-button input:hover {
    background-color: #262626;
    border: 1px solid #262626;
    cursor: pointer;
}


@media screen and (max-width: 768px) {
    .featured {
        height: 400px;
    }
}


// Styles déplacés dans les composants FilterDropdown et ActiveFiltersBar

.search-section {
    width: 100%;
    margin-bottom: 30px;

    .search-list {
        display: flex;
        justify-content: center;
        text-align: left;
        flex-wrap: wrap;
    }
}

</style>

<style lang="scss">
// Style global pour forcer l'affichage des dropdowns actifs
.to-buy-page-template .page-header-section .search-section .search-list .list .box-detail {
    &.boxblock {
        display: block !important;
    }

    .checklist {
        .check-box-custom {
            display: flex !important;
            align-items: center;

            .data {
                display: block !important;
                visibility: visible !important;
                opacity: 1 !important;
                color: #000 !important;
                font-size: 14px;
            }
        }
    }
}
</style>

<style src="@vueform/slider/themes/default.css"></style>
